/**
 * @flow
 * @relayHash d7d64c829bd03a6ee98b5be461750727
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectCreate_MutationVariables = {|
  input: {
    name: string,
    owner_id?: ?string,
    notes?: ?string,
    tracks?: ?$ReadOnlyArray<?{
      track_id: string,
      version: string,
    }>,
    clientMutationId?: ?string,
  },
|};
export type projectCreate_MutationResponse = {|
  +createProject: ?{|
    +new_project_edge: ?{|
      +node: ?{|
        +id: string,
        +name: string,
        +tracks: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +id: string,
          |}>,
        |},
      |},
    |},
  |},
|};
*/


/*
mutation projectCreate_Mutation(
  $input: CreateProjectInput!
) {
  createProject(input: $input) {
    new_project_edge {
      node {
        id
        name
        tracks(first: 100) {
          edges {
            id
            cursor
            node {
              __typename
              id
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateProjectInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CreateProjectInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "projectCreate_Mutation",
  "id": null,
  "text": "mutation projectCreate_Mutation(\n  $input: CreateProjectInput!\n) {\n  createProject(input: $input) {\n    new_project_edge {\n      node {\n        id\n        name\n        tracks(first: 100) {\n          edges {\n            id\n            cursor\n            node {\n              __typename\n              id\n            }\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "createProject",
          "new_project_edge",
          "node",
          "tracks"
        ]
      }
    ]
  },
  "fragment": {
    "kind": "Fragment",
    "name": "projectCreate_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateProjectPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_project_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Project",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": "tracks",
                    "name": "__project_tracks_connection",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProjectTrackConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectTrackEdge",
                        "plural": true,
                        "selections": [
                          v2,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TrackSearchResult",
                            "plural": false,
                            "selections": [
                              v5
                            ]
                          }
                        ]
                      },
                      v6
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "projectCreate_Mutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createProject",
        "storageKey": null,
        "args": v1,
        "concreteType": "CreateProjectPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "new_project_edge",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectEdge",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Project",
                "plural": false,
                "selections": [
                  v2,
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tracks",
                    "storageKey": "tracks(first:100)",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100,
                        "type": "Int"
                      }
                    ],
                    "concreteType": "ProjectTrackConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProjectTrackEdge",
                        "plural": true,
                        "selections": [
                          v2,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "node",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TrackSearchResult",
                            "plural": false,
                            "selections": [
                              v5,
                              v2
                            ]
                          }
                        ]
                      },
                      v6
                    ]
                  },
                  {
                    "kind": "LinkedHandle",
                    "alias": null,
                    "name": "tracks",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100,
                        "type": "Int"
                      }
                    ],
                    "handle": "connection",
                    "key": "project_tracks",
                    "filters": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = '7f2bb0bfd9f93c1a950586fdc89c24e5';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/projectCreate_Mutation.graphql.js